// components/hero.jsx
import React, { useState, useEffect } from 'react';
import './styles/hero.css';

const Hero = () => {
  const [typedText, setTypedText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [phraseIndex, setPhraseIndex] = useState(0);

  const phrases = [
    "We don't follow trends. We design them.",
    "We build brands that perform.",
    "From concept to conversion."
  ];

  useEffect(() => {
    const currentPhrase = phrases[phraseIndex];
    
    const timer = setTimeout(() => {
      if (isDeleting) {
        setTypedText(currentPhrase.substring(0, typedText.length - 1));
        if (typedText.length === 0) {
          setIsDeleting(false);
          setPhraseIndex((phraseIndex + 1) % phrases.length);
        }
      } else {
        setTypedText(currentPhrase.substring(0, typedText.length + 1));
        if (typedText === currentPhrase) {
          setTimeout(() => setIsDeleting(true), 2000);
        }
      }
    }, isDeleting ? 30 : 80);

    return () => clearTimeout(timer);
  }, [typedText, isDeleting, phraseIndex]);

  return (
    <section id="hero" className="hero">
      <video className="hero-video" autoPlay loop muted playsInline>
        <source src="https://assets.mixkit.co/videos/preview/mixkit-digital-animation-of-futuristic-devices-34486-large.mp4" type="video/mp4" />
      </video>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">
          {typedText}
          <span className="cursor-blink"></span>
        </h1>
        <p className="hero-subtitle">
          We build products that perform and campaigns that convert        </p>
        <a href="#process" className="cta-button">Explore</a>
      </div>
    </section>
  );
};

export default Hero;